export default __webpack_public_path__ + "static/media/int_databricks.98b29f13.svg";